import Form from 'components/Form';

import {
  Box,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import {
  KCPATStyledTableCell,
  KCPATStyledTableCellFirst,
  KCPATStyledTableCellHead,
  KCPATStyledTableCellBodyNumbering,
} from 'routes/Main/style';
import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';
import SectionTitle from '../../components/SectionTitle';
import MuiRadioGroup from './components/MuiRadioGroup';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
}

const contentLabel = [
  {
    id: '가. 체성통증\n(위치: 피부, 근육, 뼈의 통증)',
    ko: [
      '쑤시다.',
      '결리다.',
      '뻐개지는 듯하다.',
      '찢어지는 듯하다.',
      '찌르다',
      '묵지근하다.',
    ],
    idForApi: 'clinical_observation',
    koForApi: [
      'no_2_a_1',
      'no_2_a_2',
      'no_2_a_3',
      'no_2_a_4',
      'no_2_a_5',
      'no_2_a_5',
    ],
    desc: Array(1).fill(' '),
  },
  {
    id: '나. 내장성 통증\n(위치: 장기나 내장의 통증)',
    ko: [
      '뻐근하다.',
      '쑤시다.',
      '쓰리다.',
      '뒤틀리다.',
      '쥐어짜는 듯하다.',
      '묵직하다.',
    ],
    idForApi: 'treatment',
    koForApi: [
      'no_2_b_1',
      'no_2_b_2',
      'no_2_b_3',
      'no_2_b_4',
      'no_2_b_5',
      'no_2_b_6',
    ],
    desc: Array(1).fill(' '),
  },
  {
    id: '다. 신경병성 통증\n(위치: 신경의 통증) ',
    ko: [
      '화끈거리다.',
      '저리다.',
      '피부가 닿기만 해도 아프다.',
      '뻗치다.',
      '찌릿찌릿하다.',
    ],
    idForApi: 'intubation',
    koForApi: ['no_2_c_1', 'no_2_c_2', 'no_2_c_3', 'no_2_c_4', 'no_2_c_5'],
    desc: Array(1).fill(' '),
  },
  {
    id: '라. 기타 통증어휘 표현',
    ko: [' '],
    idForApi: 'medication',
    koForApi: ['no2_d'],
    desc: Array(1).fill(' '),
  },
];

const PainCharacter = (props: Props) => {
  const { disabled, setValue, getValues, register } = props;

  return (
    <>
      <SectionTitle title="2. 통증의 성격" mt={3} />
      <Box sx={{ width: '100%', margin: '48px auto 0 auto' }}>
        <Typography
          sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '10px' }}
        >
          Body chart를 참고하여 작성하신 통증 부위의 평균통증강도를 표시하세요.
        </Typography>
        <Box sx={{ width: '80%' }}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <KCPATStyledTableCellHead colSpan={1} align="left">
                  통증의 성격
                </KCPATStyledTableCellHead>
                <KCPATStyledTableCellHead colSpan={1} align="left">
                  반응
                </KCPATStyledTableCellHead>
                <KCPATStyledTableCellHead colSpan={1} align="left">
                  아주약간(1점)
                  {'                                '}
                  약간 (2점)
                  {'                                  '}
                  보통(3점)
                  {'                                   '}
                  심함(4점)
                  {'                                  '}
                  아주 심함(5점)
                </KCPATStyledTableCellHead>
              </TableRow>
            </TableHead>
            <TableBody>
              {contentLabel.map(
                (
                  content: {
                    id: string;
                    ko: string[];
                    desc: string[];
                    koForApi: string[];
                    idForApi: string;
                  },
                  i
                ) => {
                  return (
                    <TableRow>
                      <KCPATStyledTableCellFirst
                        align="left"
                        sx={{
                          minWidth: '100px',
                          whiteSpace: 'pre',
                          height: '44px',
                        }}
                      >
                        {content.id}
                      </KCPATStyledTableCellFirst>
                      <KCPATStyledTableCell>
                        {content.ko.map((el, i) => {
                          if (content.id === '라. 기타 통증어휘 표현') {
                            return (
                              <TableRow
                                sx={{
                                  lineHeight: '43.5px',
                                  borderBottom:
                                    i !== content.ko.length - 1
                                      ? '1px solid lightgray'
                                      : '',
                                }}
                              >
                                <Box
                                  sx={{
                                    width: '220px',
                                    whiteSpace: 'pre',
                                    padding: '0 0 0 5px',
                                  }}
                                >
                                  <Form.MuiTextField
                                    disabled={disabled}
                                    required={false}
                                    sx={{
                                      marginTop: '3px',
                                    }}
                                    placeholder="ex. 짓누르는 듯하다."
                                    {...register('no2_d_input')}
                                  />
                                </Box>
                              </TableRow>
                            );
                          }
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43.5px',
                                borderBottom:
                                  i !== content.ko.length - 1
                                    ? '1px solid lightgray'
                                    : '',
                              }}
                            >
                              <Box
                                sx={{
                                  width: '220px',
                                  whiteSpace: 'pre',
                                  padding: '0 0 0 5px',
                                }}
                              >
                                {content.ko[i]}
                              </Box>
                            </TableRow>
                          );
                        })}
                      </KCPATStyledTableCell>

                      {content.desc.map((_, descIdx) => {
                        return (
                          <KCPATStyledTableCellBodyNumbering>
                            {content.ko.map((_, koIdx) => {
                              return (
                                <TableRow
                                  sx={{
                                    lineHeight: '43.5px',
                                    borderBottom:
                                      koIdx !== content.ko.length - 1
                                        ? '1px solid lightgray'
                                        : 'none',
                                  }}
                                >
                                  <Box
                                    sx={{
                                      // width: '720px',
                                      textAlign: 'center',
                                    }}
                                  >
                                    <MuiRadioGroup
                                      values={[1, 2, 3, 4, 5]}
                                      disabled={disabled}
                                      defaultValue={getValues(
                                        `${content.koForApi[koIdx]}`
                                      )}
                                      onChange={v =>
                                        setValue(
                                          `${content.koForApi[koIdx]}`,
                                          v
                                        )
                                      }
                                      sx={{
                                        height: '43.5px',
                                        marginLeft: '50px',
                                      }}
                                    />
                                  </Box>
                                </TableRow>
                              );
                            })}
                          </KCPATStyledTableCellBodyNumbering>
                        );
                      })}
                    </TableRow>
                  );
                }
              )}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </>
  );
};

export default PainCharacter;
